// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-4adf54ff] .van-nav-bar {
  background-color: #fff;
}
[data-v-4adf54ff] .van-tabs__line {
  background-color: #ff6b35;
}
[data-v-4adf54ff] .van-tab--active {
  color: #ff6b35;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
